import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms'; 
//import {SharedModule} from '../shared/shared.module';
@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    standalone: true,
    imports: [FormsModule],
})
export class SpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
